import { apiService } from '../api/axiosClient'

export const onStateUpdate = async (data, status, cb) => {
    await apiService.put(`/proc/${data.orderid}/${data.cartid}`, {
        "order_status": status
    }).then(response => {
        cb && cb();
    }).catch(error => {
        console.error(error)
    })
}
